import React from 'react'
    
const CardPreview = () => {

    return (
        <div>CardPreview</div>
      )
    }
    
export default CardPreview;